module.exports = __webpack_public_path__ + "img/32.e7a4f0ae.jpg";